var _desc, _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigurePipePressureDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520 260",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Pressure drop in a straight circular pipe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "description"
  }, "A straight pipe with length, inner diameter, roughness, flow and pressure drop marked.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l10 5-10 5z",
    fill: "#001e1d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#001e1d",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 91h380v78H70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 106h380M70 154h380",
    stroke: "#86ceb2",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 58h318",
    markerStart: "url(#arrow)",
    markerEnd: "url(#arrow)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 68v23M419 68v23",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 101v58",
    markerStart: "url(#arrow)",
    markerEnd: "url(#arrow)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 101h32M450 159h32",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 130h155",
    markerEnd: "url(#arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 145l19-18",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 148l19-18M157 151l19-18",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#001e1d",
    fontFamily: "Arial, sans-serif",
    fontSize: 19
  }, /*#__PURE__*/React.createElement("text", {
    x: 252,
    y: 47,
    textAnchor: "middle"
  }, "L"), /*#__PURE__*/React.createElement("text", {
    x: 487,
    y: 136
  }, "Di"), /*#__PURE__*/React.createElement("text", {
    x: 244,
    y: 119
  }, "Q, u"), /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 177
  }, "\u03B5"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 217
  }, "p\u2081"), /*#__PURE__*/React.createElement("text", {
    x: 423,
    y: 217
  }, "p\u2082"), /*#__PURE__*/React.createElement("text", {
    x: 221,
    y: 235
  }, "\u0394p = p\u2081 \u2212 p\u2082"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigurePipePressureDrop);
export default __webpack_public_path__ + "static/media/calc-figure-pipe-pressure-drop.feadb1f08aaa15da527efb25032f952e.svg";
export { ForwardRef as ReactComponent };